import React, { useEffect, useState } from "react";
import Loading from "../components/common/Loading";
import InfiniteScroll from "react-infinite-scroll-component";
import { httpReauest } from "../utils/httpRequest";
import { Shamsi } from "basic-shamsi";
import { BASE_URL, CDN_BASE_URL } from "../config";
import CustomModal from "../components/common/Modal";
import { FaAngleLeft, FaBox, FaTable, FaTimes, FaUser } from "react-icons/fa";
import { toast } from "react-toastify";
import { priceComma } from "../utils/priceComma";
import { Link } from "react-router-dom";
import { FaFilePdf } from "react-icons/fa6";
import FileUploadComponent from "../components/common/OrderFiles";

const OrdersPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState();
  const [hasmore, sethasmore] = useState(true);
  const [show, setShow] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showUser, setShowUser] = useState(false);
  const [selected, setselcted] = useState();
  const [codeSelected, setCodeSelected] = useState();
  const [step, setstep] = useState(1);
  const [postCode, setpostCode] = useState();
  const [codes, setCodes] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    const page = products.length / 10 + 1;
    await httpReauest("GET", "/order?page=" + page + "&limit=10", {}, {}).then(
      ({ data }) => {
        if (data?.data?.length < 10) {
          sethasmore(false);
        }
        setProducts(data.data);
      }
    );
    setLoading(false);
  }

  async function fetchData() {
    const page = products.length / 10 + 1;
    await httpReauest("GET", "/order?page=" + page + "&limit=10", {}, {}).then(
      ({ data }) => {
        setProducts((cur) => [...cur, ...data.data]);

        if (data?.data?.length < 10) {
          sethasmore(false);
        }
      }
    );
  }

  async function approve() {
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/order/approve/" + selected._id,
      {},
      {
        "x-access-token": user.token,
      }
    ).then(({ status }) => {
      if (status === 201) {
        toast.success(
          "سفارش تایید شد و پیامک تایید بزودی به مشتری ارسال میشود"
        );
        getData();
        setstep(2);
      }
    });
  }

  async function sendOrder() {
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/order/sended/" + selected._id,
      {},
      {
        "x-access-token": user.token,
      }
    ).then(({ status }) => {
      if (status === 201) {
        toast.success("سفارش تغییر وضعیت به ارسال شده شد");
        getData();
        setselcted(null);
      }
    });
  }

  async function handleCodes(params) {
    if (!codes[0]) {
      return toast.error("موارد خالی هستند");
    }
    const user = JSON.parse(localStorage.getItem("user"));
    await httpReauest(
      "POST",
      "/order/codes/" + selected._id,
      {
        codes,
        productId: codeSelected?._id,
      },
      {
        "x-access-token": user.token,
      }
    ).then(({ status }) => {
      if (status === 201) {
        toast.success("موفقیت آمیز");
        setselcted(null);
        getData();
        setShow(false);
      }
    });
  }

  return (
    <div>
      {showUser && (
        <>
          <div
            className="w-full h-full fixed top-0 left-0 bg-black/50 z-30"
            onClick={() => setShowUser(false)}
          ></div>
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-[16px] p-4 z-40 w-[350px]">
            <h5 className="text-center font-bold text-[20px] mb-3">
              اطلاعات کاربر
            </h5>
            <span className="p-2 flex justify-between flex-wrap gap-3">
              <span>نام و نام خانوادگی :</span>
              <span dir="ltr">{selected?.name}</span>
            </span>
            <span className="p-2 flex justify-between flex-wrap gap-3">
              <span>شماره تماس:</span>
              <span dir="ltr">{selected?.phone}</span>
            </span>
            <span className="p-2 flex justify-between flex-wrap gap-3">
              <span>ایمیل:</span>
              <span dir="ltr">{selected?.email}</span>
            </span>
            <span className="p-2 flex justify-between flex-wrap gap-3">
              <span>استان:</span>
              <span dir="ltr">{selected?.state}</span>
            </span>
            <span className="p-2 flex justify-between flex-wrap gap-3">
              <span>شهر:</span>
              <span dir="ltr">{selected?.city}</span>
            </span>{" "}
            <span className="p-2 flex justify-between flex-wrap gap-3">
              <span>کد پستی:</span>
              <span dir="ltr">{selected?.postalCode}</span>
            </span>{" "}
            <span className="p-2 flex justify-between flex-wrap gap-3">
              <span>تاریخ سفارش :</span>
              <span dir="ltr">
                {" "}
                {Shamsi.format(
                  "yyyy/MM/dd - hh:mm",
                  new Date(selected?.createdAt)
                )}
              </span>
            </span>
            <span className="p-2 flex">
              <span>آدرس:</span>
              <span dir="ltr">{selected?.address}</span>
            </span>{" "}
          </div>
        </>
      )}
      {show && (
        <>
          <div
            className="w-full h-full fixed top-0 left-0 bg-black/50 z-30"
            onClick={() => setShow(false)}
          ></div>
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-[16px] p-4 z-40 w-[350px]">
            <h5 className="text-center font-bold text-[20px] mb-3">
              وارد کردن کد IMEI
            </h5>
            <h6>
              محصول : <br />
              {codeSelected?.product?.name} {codeSelected?.color}{" "}
              {codeSelected?.storage}
            </h6>
            <div className="flex flex-col mt-4 gap-3">
              {Array(codeSelected?.count)
                .fill("")
                .map((e, index) => (
                  <input
                    onChange={(e) => {
                      let newCodes = codes;
                      newCodes[index] = e.target.value;
                      setCodes(newCodes);
                    }}
                    placeholder={`کد imei محصول ${index + 1}`}
                    className="form-brand w-full"
                  />
                ))}
            </div>
            <div className="mt-3 flex justify-center">
              <button onClick={handleCodes} className="btn-brand">
                تایید
              </button>
            </div>
          </div>
        </>
      )}

      {showUpload && (
        <>
          <div
            className="w-full h-full fixed top-0 left-0 bg-black/50 z-30"
            onClick={() => setShowUpload(false)}
          ></div>
          <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white rounded-[16px] p-4 z-40 ">
            <FileUploadComponent orderId={selected?._id} />
          </div>
        </>
      )}
      <div className="w-full">
        <div className=" mb-10">
          <h1 className="title">سفارشات</h1>
        </div>

        <InfiniteScroll
          dataLength={products?.length ? products?.length : 10} //This is important field to render the next data
          next={fetchData}
          hasMore={hasmore}
          loader={"Loading..."}
        >
          {loading ? (
            <Loading />
          ) : (
            <>
              {selected ? (
                <div className="rounded-[12px] p-3 bg-white ">
                  <h2 className="font-bold text-lg justify-between gap-3 lg:items-center flex lg:flex-row flex-col">
                    جزئیات سفارش {selected?.id}#{" "}
                    <div className="flex flex-wrap items-center gap-2">
                      <button
                        onClick={() => setShowUpload(true)}
                        className="bg-emerald-700 text-white flex gap-1 items-center px-3 text-[14px] font-[400] rounded-[8px] py-1 cursor-pointer "
                      >
                        بارگذاری فایل
                        <FaFilePdf />
                      </button>
                      <Link
                        to={BASE_URL + "/order/csv/" + selected?._id}
                        download
                        className="bg-blue-600 text-white flex gap-1 items-center px-3 text-[14px] font-[400] rounded-[8px] py-1 cursor-pointer "
                      >
                        خروجی اکسل
                        <FaTable />
                      </Link>
                      {selected?.status !== "ارسال شده" && (
                        <button
                          onClick={sendOrder}
                          className="bg-green-600 text-white flex gap-1 items-center px-3 text-[14px] font-[400] rounded-[8px] py-1 cursor-pointer "
                        >
                          تبدیل به ارسال شده
                          <FaBox />
                        </button>
                      )}

                      <button
                        onClick={() => setShowUser(true)}
                        className="bg-slate-800 text-white flex gap-1 items-center px-3 text-[14px] font-[400] rounded-[8px] py-1 cursor-pointer "
                      >
                        مشخصات کاربر
                        <FaUser />
                      </button>

                      <button
                        onClick={() => setselcted(null)}
                        className="bg-red-500 text-white flex gap-1 items-center px-3 text-[14px] font-[400] rounded-[8px] py-1 cursor-pointer "
                      >
                        بازگشت
                        <FaAngleLeft />
                      </button>
                    </div>
                  </h2>
                  <div className="mt-3">
                    <ol class="flex  items-center w-full  text-center text-gray-500 dark:text-gray-400 text-[14px]">
                      <li class="flex md:w-full items-center text-green-600 dark:text-green-500 sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700">
                        <span class="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500 whitespace-nowrap">
                          <svg
                            class="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                          منتظر تایید
                        </span>
                      </li>
                      <li class="flex md:w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700">
                        <span
                          class={`${
                            selected.status == "تایید شده منتظر ارسال" ||
                            selected.status == "ارسال شده"
                              ? "dark:after:text-green-500 text-green-600 dark:text-green-500"
                              : "dark:after:text-gray-500 text-gray-600 dark:text-gray-500"
                          } flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200  whitespace-nowrap`}
                        >
                          {selected.status == "تایید شده منتظر ارسال" ||
                          selected.status == "ارسال شده" ? (
                            <svg
                              class="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          ) : (
                            <span class="me-2">2</span>
                          )}
                          در انتظار ارسال
                        </span>
                      </li>
                      <li
                        class={`${
                          selected.status == "ارسال شده"
                            ? "dark:after:text-green-500 text-green-600 dark:text-green-500"
                            : "dark:after:text-gray-500 text-gray-600 dark:text-gray-500"
                        } flex items-center whitespace-nowrap `}
                      >
                        {selected.status == "ارسال شده" ? (
                          <svg
                            class="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        ) : (
                          <span class="me-2">3</span>
                        )}
                        ارسال شده
                      </li>
                    </ol>
                    <div className="flex justify-between mt-3 items-end flex-wrap gap-3 w-full overflow-x-auto">
                      <div class="overflow-x-auto w-full max-w-[94vw]">
                        <div class="inline-block  py-2 w-full">
                          <div class="">
                            <table class=" text-left text-sm font-light w-full">
                              <thead class="border-b  font-medium border-neutral-500 text-white bg-red-600">
                                <tr>
                                  <th scope="col" class="px-6 py-3">
                                    نام محصول
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                    رنگ
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                    تعداد
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                    حافظه
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                    سایز
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                    قیمت
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                    کد imei
                                  </th>
                                  <th scope="col" class="px-6 py-3">
                                    وارد کردن کد imei
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {selected?.products?.map((item) => (
                                  <tr class="border-b bg-neutral-100 ">
                                    <td class="whitespace-nowrap px-6 py-3">
                                      {item?.product?.name}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-3">
                                      {item?.color}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-3">
                                      {item?.count}x
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-3">
                                      {item?.storage ? item?.storage : "___"}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-3">
                                      {item?.size ? item?.size : "___"}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-3">
                                      {item?.price}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-3">
                                      {item?.codes?.length
                                        ? item?.codes?.map((code) => (
                                            <>
                                              {code}
                                              <br />
                                            </>
                                          ))
                                        : "___"}
                                    </td>
                                    <td class="whitespace-nowrap px-6 py-3">
                                      <button
                                        onClick={() => {
                                          setCodeSelected(item);
                                          setShow(true);
                                        }}
                                        className="text-blue-500 font-bold"
                                      >
                                        وارد کردن
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <span className="font-bold text-[22px]">
                      AED {priceComma(selected?.allPrice, 2)}
                    </span>
                  </div>
                </div>
              ) : (
                <div className="rounded-[12px] p-3 bg-white ">
                  {products?.map((item) => (
                    <div
                      onClick={() => setselcted(item)}
                      className="border p-[12px] rounded-md mt-3 hover:bg-slate-100 duration-200 cursor-pointer"
                    >
                      <div className="mb-2 flex justify-between items-center">
                        <span className=" font-bold text-[18px]">
                          سفارش {item?.id}#
                        </span>
                        <span
                          dir="ltr"
                          className="font-bold bg-green-200 px-3 rounded text-green-600 pt-1"
                        >
                          {new Date(item.createdAt).toLocaleString()}
                        </span>
                      </div>
                      <ol class="flex  items-center w-full  text-center text-gray-500 dark:text-gray-400 text-[14px]">
                        <li class="flex md:w-full items-center text-green-600 dark:text-green-500 sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700">
                          <span class="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 dark:after:text-gray-500 whitespace-nowrap">
                            <svg
                              class="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                            منتظر تایید
                          </span>
                        </li>
                        <li class="flex md:w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10 dark:after:border-gray-700">
                          <span
                            class={`${
                              item.status == "تایید شده منتظر ارسال" ||
                              item.status == "ارسال شده"
                                ? "dark:after:text-green-500 text-green-600 dark:text-green-500"
                                : "dark:after:text-gray-500 text-gray-600 dark:text-gray-500"
                            } flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200  whitespace-nowrap`}
                          >
                            {item.status == "تایید شده منتظر ارسال" ||
                            item.status == "ارسال شده" ? (
                              <svg
                                class="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                              </svg>
                            ) : (
                              <span class="me-2">2</span>
                            )}
                            در انتظار ارسال
                          </span>
                        </li>
                        <li
                          class={`${
                            item.status == "ارسال شده"
                              ? "dark:after:text-green-500 text-green-600 dark:text-green-500"
                              : "dark:after:text-gray-500 text-gray-600 dark:text-gray-500"
                          } flex items-center whitespace-nowrap `}
                        >
                          {item.status == "ارسال شده" ? (
                            <svg
                              class="w-3.5 h-3.5 sm:w-4 sm:h-4 me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          ) : (
                            <span class="me-2">3</span>
                          )}
                          ارسال شده
                        </li>
                      </ol>
                      <div className="flex justify-between mt-3 items-end flex-wrap gap-3">
                        <span className=" flex gap-2 flex-wrap">
                          {item?.products?.map((pro) => (
                            <span className="flex flex-col gap-1 items-center border p-1">
                              <span>{pro?.product?.name}</span>
                              <span>{pro?.storage}</span>
                              <span>
                                {pro?.color} {pro?.count}x
                              </span>
                              <span>{priceComma(pro?.buy_price, 2)} AED</span>
                            </span>
                          ))}
                        </span>
                        <span className="font-bold text-[22px]">
                          AED {priceComma(item?.allPrice, 2)}
                        </span>
                      </div>
                      <div className="mt-4 bg-slate-600 text-white p-2 rounded-[8px] flex items-center gap-1">
                        <FaUser color="white" /> {item.name}-{item?.phone}-
                        {item?.state}-{item?.city}-{item?.address}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default OrdersPage;
